import { useAppSelector } from "screens/Root/hooks/useAppSelector";
import { useState } from "react";
import { IconButton } from "../../../components/IconButton";
import StyledMenuItem from "../../TopMenu/components/StyledMenuItem";
import SubmenuLabel from "../../TopMenu/components/SubmenuLabel";
import { HelpMenu } from "./HelpMenu";
import { ShortcutsModal } from "./HelpModal";
const HeaderHelpIcon = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [shortcutsModalOpen, setShortcutsModalOpen] = useState(false);
    const url = useAppSelector(({ root }) => root.appSettings).HelpUrl;
    const handleOpenMenuClick = ({ target }) => setAnchorEl(target);
    const handleHelpClick = () => {
        window.open(url, "_blank");
        handleMenuClose();
    };
    const handleShortcutsClick = () => {
        setShortcutsModalOpen(true);
        handleMenuClose();
    };
    const handleMenuClose = () => setAnchorEl(null);
    const handleModalClose = () => setShortcutsModalOpen(false);
    return (<>
      <ShortcutsModal open={shortcutsModalOpen} onClose={handleModalClose}/>
      <HelpMenu anchorEl={anchorEl} onClose={handleMenuClose}>
        <StyledMenuItem onClick={handleHelpClick}>
          <SubmenuLabel>Help</SubmenuLabel>
        </StyledMenuItem>
        <StyledMenuItem onClick={handleShortcutsClick} style={{ borderBottomWidth: 0 }}>
          <SubmenuLabel>Keyboard Shortcuts</SubmenuLabel>
        </StyledMenuItem>
      </HelpMenu>
      <IconButton type="font-awesome" onClick={handleOpenMenuClick} tooltip="Help" identification="header-help">
        question-circle
      </IconButton>
    </>);
};
export default HeaderHelpIcon;
